import { Box, ListItemText, Menu, styled, Typography } from '@mui/material';
import { ReactComponent as AngleDown } from 'images/header/angle-down.svg';
import Background from 'images/header/header-background.png';

export const HeaderWrapper = styled(Box)(({ theme }) => ({
  width              : '100%',
  height             : '88px',
  padding            : '14px 78px',
  display            : 'flex',
  justifyContent     : 'space-between',
  alignItems         : 'center',
  boxSizing          : 'border-box',
  position           : 'relative',
  background         : `url(${Background})`,
  backgroundRepeat   : 'no-repeat',
  backgroundPosition : 'center',
  backgroundSize     : 'cover',
  backgroundColor    : theme.palette.primary.white,
}));

export const BackgroundBanner = styled(Box)(({ theme }) => ({
  display  : 'flex',
  position : 'absolute',
}));

// export const UserProfileMenu = styled(Box)(({ theme }) => ({
//   width: '170px',
// }));

export const UserProfileMenuToggleButton = styled('button')({
  display         : 'flex',
  justifyContent  : 'space-between',
  alignItems      : 'center',
  backgroundColor : 'transparent',
  border          : '0px',
  width           : '100%',
  cursor          : 'pointer',
});

export const UserName = styled(Typography)({
  fontFamily  : 'Montserrat',
  marginRight : '12px',
});

export const StyledAngle = styled(AngleDown, {
  shouldForwardProp : (props) => props !== 'isMenuOpen',
})(({ isMenuOpen }) => ({
  transform  : `rotate(${isMenuOpen ? 180 : 0}deg)`,
  marginLeft : '12px',
}));

export const StyledListItemText = styled(ListItemText, {
  shouldForwardProp : (props) => props !== 'isActive',
})(({ isActive }) => ({
  '& .MuiTypography-root' : {
    fontSize    : '14px',
    lineHeight  : '24px',
    marginRight : '50px',
    color       : isActive ? '#00778B' : '#6A6A6A',
  },
}));

export const StyledMenu = styled(Menu)({
  '& .MuiMenu-paper' : {
    right      : '78px',
    width      : '239px',
    marginLeft : '-60px',
  },
});
